import React from "react";
import Button from "@bit/the-glue.frontendcomponents.button";

export const ListButton = ({ label, size = "small", className,...other }) => {
  return (
    <Button
      label={label}
      size={size}
      className={className}
      // text="blue"
      // background="#fff"
      background="#64A70B"
      text="#E8F5E1"
      boxShadow
      textTransform="uppercase"
      fontWeight="500"
      fontSize="12px"
      {...other}
    />
  );
};
